export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Upload: any;
};






export type AddPackageInput = {
  trackingNumber: Scalars['String'];
  shippingCompany: Scalars['String'];
  shippingGroupId?: Maybe<Scalars['ID']>;
  shippingGroupPrivateCode?: Maybe<Scalars['String']>;
  items?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  warehouseNotes?: Maybe<Scalars['String']>;
};

export type AddShippingGroupInput = {
  name: Scalars['String'];
  zipCode: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  country: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  notice?: Maybe<Scalars['String']>;
  type: ShippingGroupType;
  status?: Maybe<ShippingGroupStatus>;
  deadline?: Maybe<Scalars['DateTime']>;
  leaderId?: Maybe<Scalars['ID']>;
  minWeight?: Maybe<Scalars['Float']>;
  countdownSeconds?: Maybe<Scalars['Int']>;
  hasFixedLeader?: Maybe<Scalars['Boolean']>;
  shippingService?: Maybe<Scalars['String']>;
  privateCode?: Maybe<Scalars['String']>;
};

export type AddUserInput = {
  wechatName?: Maybe<Scalars['String']>;
  wechatId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  isOperator?: Maybe<Scalars['Boolean']>;
  operatorId?: Maybe<Scalars['ID']>;
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type BatchPackageInput = {
  warehouseNotes?: Maybe<Scalars['String']>;
  status?: Maybe<PackageStatus>;
};

export type Bill = {
  __typename?: 'Bill';
  year: Scalars['Int'];
  month: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  packagesCount: Scalars['Int'];
  paid: Scalars['Boolean'];
};

export type BooleanFilter = {
  equals?: Maybe<Scalars['Boolean']>;
};

export type CreateShippingGroupOrderResult = {
  __typename?: 'CreateShippingGroupOrderResult';
  order: Order;
  newShippingGroup?: Maybe<ShippingGroup>;
};

export type DashboardStats = {
  __typename?: 'DashboardStats';
  pendingCount: Scalars['Int'];
  receivedCount: Scalars['Int'];
  problemCount: Scalars['Int'];
};


export type DateTimeFilter = {
  before?: Maybe<Scalars['DateTime']>;
  after?: Maybe<Scalars['DateTime']>;
};

export type GroupMembership = {
  __typename?: 'GroupMembership';
  user: User;
  canBeLeader: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type IdFilter = {
  equals?: Maybe<Scalars['ID']>;
  not?: Maybe<Scalars['ID']>;
  in?: Maybe<Array<Scalars['ID']>>;
};

export type MembershipUpdateInput = {
  canBeLeader: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  signupAdmin: AuthPayload;
  signup: AuthPayload;
  login: AuthPayload;
  changePassword: User;
  addUser: User;
  updateUser: User;
  deleteUser: User;
  addPackage: Package;
  operatorAddPackage: Package;
  updatePackage: Package;
  updatePackages: Scalars['Int'];
  deletePackage: Package;
  addShippingGroup: ShippingGroup;
  updateShippingGroup: ShippingGroup;
  deactivateShippingGroup: ShippingGroup;
  transferShippingGroup: ShippingGroup;
  acceptTransferShippingGroup: ShippingGroup;
  createShippingGroupOrder: CreateShippingGroupOrderResult;
  removePackagesFromOrder: Array<Package>;
  addOrder: Order;
  updateOrder: Order;
  cancelOrder: Order;
  setNotificationsRead: Scalars['Int'];
  createTicket: Ticket;
  replyTicket: Ticket;
  generateBill?: Maybe<Bill>;
  addShippingRoute: ShippingRoute;
  updateShippingRoute: ShippingRoute;
};


export type MutationSignupAdminArgs = {
  password: Scalars['String'];
  wechatName?: Maybe<Scalars['String']>;
  wechatId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};


export type MutationSignupArgs = {
  code?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  wechatName?: Maybe<Scalars['String']>;
  wechatId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['ID']>;
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
};


export type MutationAddUserArgs = {
  user: AddUserInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['ID'];
  user: UserInput;
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID'];
};


export type MutationAddPackageArgs = {
  package: AddPackageInput;
  updateMembership?: Maybe<MembershipUpdateInput>;
};


export type MutationOperatorAddPackageArgs = {
  package: OperatorAddPackageInput;
  updateReceivedAt?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdatePackageArgs = {
  id: Scalars['ID'];
  package: PackageInput;
  updateReceivedAt?: Maybe<Scalars['Boolean']>;
  updateMembership?: Maybe<MembershipUpdateInput>;
};


export type MutationUpdatePackagesArgs = {
  ids: Array<Scalars['ID']>;
  package: BatchPackageInput;
  updateReceivedAt?: Maybe<Scalars['Boolean']>;
};


export type MutationDeletePackageArgs = {
  id: Scalars['ID'];
};


export type MutationAddShippingGroupArgs = {
  shippingGroup: AddShippingGroupInput;
};


export type MutationUpdateShippingGroupArgs = {
  id: Scalars['ID'];
  shippingGroup: ShippingGroupInput;
};


export type MutationDeactivateShippingGroupArgs = {
  id: Scalars['ID'];
};


export type MutationTransferShippingGroupArgs = {
  id: Scalars['ID'];
  newLeaderUserId: Scalars['ID'];
  transferNow?: Maybe<Scalars['Boolean']>;
};


export type MutationAcceptTransferShippingGroupArgs = {
  id: Scalars['ID'];
};


export type MutationCreateShippingGroupOrderArgs = {
  id: Scalars['ID'];
};


export type MutationRemovePackagesFromOrderArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationAddOrderArgs = {
  order: OrderInput;
};


export type MutationUpdateOrderArgs = {
  id: Scalars['ID'];
  order: OrderInput;
};


export type MutationCancelOrderArgs = {
  id: Scalars['ID'];
};


export type MutationSetNotificationsReadArgs = {
  ids: Array<Scalars['ID']>;
  read?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateTicketArgs = {
  ticket: TicketInput;
};


export type MutationReplyTicketArgs = {
  id: Scalars['ID'];
  message: TicketMessageInput;
};


export type MutationGenerateBillArgs = {
  year: Scalars['Int'];
  month: Scalars['Int'];
};


export type MutationAddShippingRouteArgs = {
  shippingRoute: ShippingRouteInput;
};


export type MutationUpdateShippingRouteArgs = {
  id: Scalars['ID'];
  shippingRoute: ShippingRouteInput;
};

export type Notification = {
  __typename?: 'Notification';
  id: Scalars['ID'];
  type: NotificationType;
  user: User;
  createdAt: Scalars['DateTime'];
  firstReadAt?: Maybe<Scalars['DateTime']>;
  from?: Maybe<User>;
  order?: Maybe<Order>;
  shippingGroup?: Maybe<ShippingGroup>;
  package?: Maybe<Package>;
  ticket?: Maybe<Ticket>;
};

export type NotificationsResult = {
  __typename?: 'NotificationsResult';
  list: Array<Notification>;
  total: Scalars['Int'];
  skip: Scalars['Int'];
  totalUnread: Scalars['Int'];
};

export enum NotificationType {
  PackageReceivedAtWarehouse = 'PACKAGE_RECEIVED_AT_WAREHOUSE',
  NewPackageReceivedAtWarehouse = 'NEW_PACKAGE_RECEIVED_AT_WAREHOUSE',
  ProblemPackageReceivedAtWarehouse = 'PROBLEM_PACKAGE_RECEIVED_AT_WAREHOUSE',
  NewProblemPackageReceivedAtWarehouse = 'NEW_PROBLEM_PACKAGE_RECEIVED_AT_WAREHOUSE',
  OrderPaymentPending = 'ORDER_PAYMENT_PENDING',
  OrderShipped = 'ORDER_SHIPPED',
  ShippingGroupOrderPickupPending = 'SHIPPING_GROUP_ORDER_PICKUP_PENDING',
  ShippingGroupOrderCreated = 'SHIPPING_GROUP_ORDER_CREATED',
  TransferShippingGroupRequest = 'TRANSFER_SHIPPING_GROUP_REQUEST',
  TicketUpdated = 'TICKET_UPDATED',
  PackageRemovedFromOrder = 'PACKAGE_REMOVED_FROM_ORDER',
  OrderCancelled = 'ORDER_CANCELLED'
}

export type Operator = {
  __typename?: 'Operator';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  wechatId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type OperatorAddPackageInput = {
  trackingNumber: Scalars['String'];
  shippingCompany: Scalars['String'];
  status: PackageStatus;
  notes?: Maybe<Scalars['String']>;
  warehouseNotes?: Maybe<Scalars['String']>;
  weight: Scalars['Float'];
  length?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  depth?: Maybe<Scalars['Float']>;
  userCode?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Scalars['Upload']>>;
};

export type Order = {
  __typename?: 'Order';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  parentOrder?: Maybe<Order>;
  subOrders?: Maybe<Array<Order>>;
  number: Scalars['String'];
  status: OrderStatus;
  paymentStatus: OrderPaymentStatus;
  paymentMethod?: Maybe<OrderPaymentMethod>;
  paymentNotes?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  warehouseNotes?: Maybe<Scalars['String']>;
  operator?: Maybe<Operator>;
  user?: Maybe<User>;
  shippingGroup?: Maybe<ShippingGroup>;
  packages?: Maybe<Array<Package>>;
  shippingService?: Maybe<Scalars['String']>;
  shippingRoute?: Maybe<ShippingRoute>;
  trackingNumber?: Maybe<Scalars['String']>;
  shippedAt?: Maybe<Scalars['DateTime']>;
  length?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  depth?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  dimWeight?: Maybe<Scalars['Float']>;
  chargeWeight?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
  totalPrice?: Maybe<Scalars['Float']>;
  totalPriceCollected?: Maybe<Scalars['Float']>;
  currencyCollected?: Maybe<Scalars['String']>;
  serviceName?: Maybe<Scalars['String']>;
  serviceProvider?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Scalars['String']>>;
  changeLog: Array<OrderLog>;
};

export enum OrderByOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderInput = {
  status?: Maybe<OrderStatus>;
  paymentStatus?: Maybe<OrderPaymentStatus>;
  paymentMethod?: Maybe<OrderPaymentMethod>;
  paymentNotes?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  warehouseNotes?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  packageIds?: Maybe<Array<Scalars['String']>>;
  trackingNumber?: Maybe<Scalars['String']>;
  shippedAt?: Maybe<Scalars['DateTime']>;
  length?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  depth?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  dimWeight?: Maybe<Scalars['Float']>;
  chargeWeight?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
  totalPrice?: Maybe<Scalars['Float']>;
  totalPriceCollected?: Maybe<Scalars['Float']>;
  currencyCollected?: Maybe<Scalars['String']>;
  serviceName?: Maybe<Scalars['String']>;
  serviceProvider?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  shippingService?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Scalars['Upload']>>;
  deleteImages?: Maybe<Array<Scalars['String']>>;
};

export type OrderLog = {
  __typename?: 'OrderLog';
  order: Order;
  updatedBy: User;
  time: Scalars['DateTime'];
  changes: Scalars['String'];
};

export type OrderOrderByInput = {
  createdAt?: Maybe<OrderByOrder>;
  updatedAt?: Maybe<OrderByOrder>;
};

export enum OrderPaymentMethod {
  WechatTransfer = 'WECHAT_TRANSFER',
  AlipayTransfer = 'ALIPAY_TRANSFER',
  TaobaoOrder = 'TAOBAO_ORDER',
  BankTransfer = 'BANK_TRANSFER'
}

export type OrderPaymentMethodFilter = {
  equals?: Maybe<OrderPaymentMethod>;
  not?: Maybe<OrderPaymentMethod>;
  in?: Maybe<Array<OrderPaymentMethod>>;
};

export enum OrderPaymentStatus {
  Unpaid = 'UNPAID',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID'
}

export type OrderPaymentStatusFilter = {
  equals?: Maybe<OrderPaymentStatus>;
  not?: Maybe<OrderPaymentStatus>;
  in?: Maybe<Array<OrderPaymentStatus>>;
};

export type OrderQueryResult = {
  __typename?: 'OrderQueryResult';
  list: Array<Order>;
  total: Scalars['Int'];
  skip: Scalars['Int'];
};

export enum OrderStatus {
  Created = 'CREATED',
  Packing = 'PACKING',
  Packed = 'PACKED',
  Shipped = 'SHIPPED',
  PickupPending = 'PICKUP_PENDING',
  UserReceived = 'USER_RECEIVED',
  Problem = 'PROBLEM',
  Cancelled = 'CANCELLED'
}

export type OrderStatusFilter = {
  equals?: Maybe<OrderStatus>;
  not?: Maybe<OrderStatus>;
  in?: Maybe<Array<OrderStatus>>;
};

export type OrderWhereInput = {
  id?: Maybe<IdFilter>;
  number?: Maybe<StringFilter>;
  status?: Maybe<OrderStatusFilter>;
  paymentStatus?: Maybe<OrderPaymentStatusFilter>;
  paymentMethod?: Maybe<OrderPaymentMethodFilter>;
  paymentNotes?: Maybe<StringFilter>;
  notes?: Maybe<StringFilter>;
  warehouseNotes?: Maybe<StringFilter>;
  operatorId?: Maybe<IdFilter>;
  userId?: Maybe<IdFilter>;
  trackingNumber?: Maybe<StringFilter>;
  serviceName?: Maybe<StringFilter>;
  serviceProvider?: Maybe<StringFilter>;
  country?: Maybe<StringFilter>;
  recipientName?: Maybe<StringFilter>;
  parentOrderId?: Maybe<IdFilter>;
  shippingGroupId?: Maybe<IdFilter>;
  AND?: Maybe<Array<OrderWhereInput>>;
  OR?: Maybe<Array<OrderWhereInput>>;
};

export type Package = {
  __typename?: 'Package';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  trackingNumber: Scalars['String'];
  shippingCompany: Scalars['String'];
  items?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  warehouseNotes?: Maybe<Scalars['String']>;
  status?: Maybe<PackageStatus>;
  weight?: Maybe<Scalars['Float']>;
  length?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  depth?: Maybe<Scalars['Float']>;
  user?: Maybe<User>;
  shippingGroup?: Maybe<ShippingGroup>;
  receivedAt?: Maybe<Scalars['DateTime']>;
  order?: Maybe<Order>;
  subOrder?: Maybe<Order>;
  images?: Maybe<Array<Scalars['String']>>;
  changeLog: Array<PackageLog>;
};

export type PackageInput = {
  trackingNumber?: Maybe<Scalars['String']>;
  shippingCompany?: Maybe<Scalars['String']>;
  shippingGroupId?: Maybe<Scalars['ID']>;
  shippingGroupPrivateCode?: Maybe<Scalars['String']>;
  items?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  warehouseNotes?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Float']>;
  length?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  depth?: Maybe<Scalars['Float']>;
  status?: Maybe<PackageStatus>;
  userCode?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Scalars['Upload']>>;
  deleteImages?: Maybe<Array<Scalars['String']>>;
};

export type PackageLog = {
  __typename?: 'PackageLog';
  package: Package;
  updatedBy: User;
  time: Scalars['DateTime'];
  changes: Scalars['String'];
};

export type PackageOrderByInput = {
  createdAt?: Maybe<OrderByOrder>;
  updatedAt?: Maybe<OrderByOrder>;
  user?: Maybe<OrderByOrder>;
  status?: Maybe<OrderByOrder>;
};

export type PackageQueryResult = {
  __typename?: 'PackageQueryResult';
  list: Array<Package>;
  total: Scalars['Int'];
  skip: Scalars['Int'];
};

export enum PackageStatus {
  WarehousePending = 'WAREHOUSE_PENDING',
  WarehouseReceived = 'WAREHOUSE_RECEIVED',
  OrderCreated = 'ORDER_CREATED',
  Cancelled = 'CANCELLED',
  Problem = 'PROBLEM'
}

export type PackageStatusFilter = {
  equals?: Maybe<PackageStatus>;
  not?: Maybe<PackageStatus>;
  in?: Maybe<Array<PackageStatus>>;
};

export type PackageWhereInput = {
  status?: Maybe<PackageStatusFilter>;
  userId?: Maybe<IdFilter>;
  trackingNumber?: Maybe<StringFilter>;
  shippingCompany?: Maybe<StringFilter>;
  notes?: Maybe<StringFilter>;
  createdAt?: Maybe<DateTimeFilter>;
  operatorId?: Maybe<IdFilter>;
  shippingGroupId?: Maybe<IdFilter>;
  orderId?: Maybe<IdFilter>;
  receivedAt?: Maybe<DateTimeFilter>;
  AND?: Maybe<Array<PackageWhereInput>>;
  OR?: Maybe<Array<PackageWhereInput>>;
};

export type Query = {
  __typename?: 'Query';
  ping: Scalars['Int'];
  users: Array<User>;
  user?: Maybe<User>;
  getUser: User;
  queryUsers: UserQueryResult;
  operators: Array<Operator>;
  shippingGroup: ShippingGroup;
  shippingGroups: Array<ShippingGroup>;
  queryShippingGroups: ShippingGroupQueryResult;
  userPackages: Array<Package>;
  packages: Array<Package>;
  getPackage: Package;
  queryPackages: PackageQueryResult;
  queryUserPackages: PackageQueryResult;
  orders: Array<Order>;
  getOrder: Order;
  queryOrders: OrderQueryResult;
  queryUserOrders: OrderQueryResult;
  notifications: NotificationsResult;
  dashboardStats: DashboardStats;
  tickets: TicketQueryResult;
  getTicket: Ticket;
  queryTickets: TicketQueryResult;
  bills: Array<Bill>;
  shippingRoutes: Array<ShippingRoute>;
  shippingRoute: ShippingRoute;
};


export type QueryGetUserArgs = {
  id: Scalars['ID'];
};


export type QueryQueryUsersArgs = {
  where: UserWhereInput;
  count?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryShippingGroupArgs = {
  id: Scalars['ID'];
};


export type QueryShippingGroupsArgs = {
  type?: Maybe<ShippingGroupType>;
  status?: Maybe<ShippingGroupStatus>;
};


export type QueryQueryShippingGroupsArgs = {
  where: ShippingGroupWhereInput;
  orderBy?: Maybe<ShippingGroupOrderByInput>;
  count?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryGetPackageArgs = {
  id: Scalars['ID'];
};


export type QueryQueryPackagesArgs = {
  where: PackageWhereInput;
  orderBy?: Maybe<PackageOrderByInput>;
  count?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryQueryUserPackagesArgs = {
  where: PackageWhereInput;
  orderBy?: Maybe<PackageOrderByInput>;
  count?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryGetOrderArgs = {
  id: Scalars['ID'];
};


export type QueryQueryOrdersArgs = {
  where: OrderWhereInput;
  orderBy?: Maybe<OrderOrderByInput>;
  count?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryQueryUserOrdersArgs = {
  where: OrderWhereInput;
  orderBy?: Maybe<OrderOrderByInput>;
  count?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryNotificationsArgs = {
  count?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryTicketsArgs = {
  count?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryGetTicketArgs = {
  id: Scalars['ID'];
};


export type QueryQueryTicketsArgs = {
  where: TicketWhereInput;
  orderBy?: Maybe<TicketOrderByInput>;
  count?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryShippingRouteArgs = {
  id: Scalars['ID'];
};

export enum ShipmentType {
  Regular = 'REGULAR',
  Food = 'FOOD',
  Both = 'BOTH'
}

export type ShippingGroup = {
  __typename?: 'ShippingGroup';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  zipCode: Scalars['String'];
  city: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  notice?: Maybe<Scalars['String']>;
  type: ShippingGroupType;
  status: ShippingGroupStatus;
  deadline?: Maybe<Scalars['DateTime']>;
  leader?: Maybe<User>;
  pendingLeader?: Maybe<User>;
  minWeight?: Maybe<Scalars['Float']>;
  countdownSeconds?: Maybe<Scalars['Int']>;
  countdownDays?: Maybe<Scalars['Int']>;
  hasFixedLeader?: Maybe<Scalars['Boolean']>;
  shippingService?: Maybe<Scalars['String']>;
  shippingRoute?: Maybe<ShippingRoute>;
  packages: Array<Package>;
  order?: Maybe<Order>;
  originalShippingGroupId?: Maybe<Scalars['ID']>;
  totalWeight?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  groupMemberships: Array<GroupMembership>;
  previousMembership?: Maybe<GroupMembership>;
  changeLog: Array<ShippingGroupLog>;
};

export type ShippingGroupInput = {
  name?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  notice?: Maybe<Scalars['String']>;
  type?: Maybe<ShippingGroupType>;
  status?: Maybe<ShippingGroupStatus>;
  deadline?: Maybe<Scalars['DateTime']>;
  leaderId?: Maybe<Scalars['ID']>;
  minWeight?: Maybe<Scalars['Float']>;
  countdownSeconds?: Maybe<Scalars['Int']>;
  hasFixedLeader?: Maybe<Scalars['Boolean']>;
  shippingService?: Maybe<Scalars['String']>;
  privateCode?: Maybe<Scalars['String']>;
};

export type ShippingGroupLog = {
  __typename?: 'ShippingGroupLog';
  shippingGroup: ShippingGroup;
  updatedBy: User;
  time: Scalars['DateTime'];
  changes: Scalars['String'];
};

export type ShippingGroupOrderByInput = {
  createdAt?: Maybe<OrderByOrder>;
  updatedAt?: Maybe<OrderByOrder>;
};

export type ShippingGroupQueryResult = {
  __typename?: 'ShippingGroupQueryResult';
  list: Array<ShippingGroup>;
  total: Scalars['Int'];
  skip: Scalars['Int'];
};

export enum ShippingGroupStatus {
  Open = 'OPEN',
  Closed = 'CLOSED',
  Cancelled = 'CANCELLED'
}

export type ShippingGroupStatusFilter = {
  equals?: Maybe<ShippingGroupStatus>;
  not?: Maybe<ShippingGroupStatus>;
  in?: Maybe<Array<ShippingGroupStatus>>;
};

export enum ShippingGroupType {
  Regular = 'REGULAR',
  Food = 'FOOD'
}

export type ShippingGroupTypeFilter = {
  equals?: Maybe<ShippingGroupType>;
  not?: Maybe<ShippingGroupType>;
  in?: Maybe<Array<ShippingGroupType>>;
};

export type ShippingGroupWhereInput = {
  id?: Maybe<IdFilter>;
  status?: Maybe<ShippingGroupStatusFilter>;
  country?: Maybe<StringFilter>;
  type?: Maybe<ShippingGroupTypeFilter>;
  AND?: Maybe<Array<ShippingGroupWhereInput>>;
  OR?: Maybe<Array<ShippingGroupWhereInput>>;
};

export enum ShippingMethod {
  Sea = 'SEA',
  Air = 'AIR'
}

export type ShippingRoute = {
  __typename?: 'ShippingRoute';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  country: Scalars['String'];
  speed: Scalars['String'];
  shippingMethod: ShippingMethod;
  shipmentType: ShipmentType;
  dimensionalFactor: Scalars['Int'];
  isActive: Scalars['Boolean'];
  canGroup: Scalars['Boolean'];
  canDirect: Scalars['Boolean'];
  groupMinWeight: Scalars['Float'];
  groupIndividualMinWeight: Scalars['Float'];
  priceRanges: Array<ShippingRoutePriceRange>;
  description: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
};

export type ShippingRouteInput = {
  name: Scalars['String'];
  country: Scalars['String'];
  speed: Scalars['String'];
  shippingMethod: ShippingMethod;
  shipmentType: ShipmentType;
  dimensionalFactor: Scalars['Int'];
  isActive: Scalars['Boolean'];
  canGroup: Scalars['Boolean'];
  canDirect: Scalars['Boolean'];
  groupMinWeight: Scalars['Float'];
  groupIndividualMinWeight: Scalars['Float'];
  priceRanges: Array<ShippingRoutePriceRangeInput>;
  description: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
};

export type ShippingRoutePriceRange = {
  __typename?: 'ShippingRoutePriceRange';
  startWeight: Scalars['Float'];
  unitPrice: Scalars['Float'];
  basePrice: Scalars['Float'];
  roundingWeight: Scalars['Float'];
};

export type ShippingRoutePriceRangeInput = {
  startWeight: Scalars['Float'];
  unitPrice: Scalars['Float'];
  basePrice: Scalars['Float'];
  roundingWeight: Scalars['Float'];
};

export type StringFilter = {
  equals?: Maybe<Scalars['String']>;
  contains?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  not?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
};

export type Ticket = {
  __typename?: 'Ticket';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  number: Scalars['String'];
  user: User;
  operator?: Maybe<User>;
  status: TicketStatus;
  shippingGroup?: Maybe<ShippingGroup>;
  package?: Maybe<Package>;
  order?: Maybe<Order>;
  messages: Array<TicketMessage>;
};

export type TicketInput = {
  message: Scalars['String'];
  images?: Maybe<Array<Scalars['Upload']>>;
  packageId?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  shippingGroupId?: Maybe<Scalars['String']>;
};

export type TicketMessage = {
  __typename?: 'TicketMessage';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  user: User;
  message?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<TicketStatus>;
  assignedOperator?: Maybe<User>;
};

export type TicketMessageInput = {
  message?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Scalars['Upload']>>;
  status?: Maybe<TicketStatus>;
  assignedOperatorId?: Maybe<Scalars['ID']>;
};

export type TicketOrderByInput = {
  createdAt?: Maybe<OrderByOrder>;
  updatedAt?: Maybe<OrderByOrder>;
};

export type TicketQueryResult = {
  __typename?: 'TicketQueryResult';
  list: Array<Ticket>;
  total: Scalars['Int'];
  skip: Scalars['Int'];
};

export enum TicketStatus {
  Open = 'OPEN',
  AwaitingCustomerResponse = 'AWAITING_CUSTOMER_RESPONSE',
  Resolved = 'RESOLVED',
  Closed = 'CLOSED'
}

export type TicketStatusFilter = {
  equals?: Maybe<TicketStatus>;
  not?: Maybe<TicketStatus>;
  in?: Maybe<Array<TicketStatus>>;
};

export type TicketWhereInput = {
  id?: Maybe<IdFilter>;
  number?: Maybe<StringFilter>;
  status?: Maybe<TicketStatusFilter>;
  userId?: Maybe<IdFilter>;
  operatorId?: Maybe<IdFilter>;
  AND?: Maybe<Array<TicketWhereInput>>;
  OR?: Maybe<Array<TicketWhereInput>>;
};


export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  wechatName?: Maybe<Scalars['String']>;
  wechatId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  isOperator?: Maybe<Scalars['Boolean']>;
  packages: Array<Package>;
  operator?: Maybe<Operator>;
  zipCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
};

export type UserInput = {
  wechatName?: Maybe<Scalars['String']>;
  wechatId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  oldPassword?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  operatorId?: Maybe<Scalars['ID']>;
  zipCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
};

export type UserQueryResult = {
  __typename?: 'UserQueryResult';
  list: Array<User>;
  total: Scalars['Int'];
  skip: Scalars['Int'];
};

export type UserWhereInput = {
  createdAt?: Maybe<DateTimeFilter>;
  wechatName?: Maybe<StringFilter>;
  wechatId?: Maybe<StringFilter>;
  name?: Maybe<StringFilter>;
  code?: Maybe<StringFilter>;
  email?: Maybe<StringFilter>;
  isAdmin?: Maybe<BooleanFilter>;
  isOperator?: Maybe<BooleanFilter>;
  operatorId?: Maybe<IdFilter>;
  AND?: Maybe<Array<UserWhereInput>>;
  OR?: Maybe<Array<UserWhereInput>>;
};
